module.exports = __webpack_public_path__ + "static/img/jigou-shandong-bottom.c0f953d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-shandong-bottom.png
// module id = yxtf
// module chunks = 2